import React, { useState, useEffect } from "react";
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from '../../composant_reutilisable/useAuth';
import { Link } from "react-router-dom";
import TableauDynamique from "../../composant_reutilisable/tableau";
import { BsPeople } from "react-icons/bs";
import { Modal, Button } from "react-bootstrap"; // Ajout du modal Bootstrap
import ModalComponent from "../../composant_reutilisable/composant_modal";
import { FaCogs, FaPlus, FaQuestionCircle, FaTrash } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import Pas_acces from "../../composant_reutilisable/pas_acces";
import axios from "axios";

const ListeGroupe = () => {
    useAuth();
    const navigate = useNavigate();

    // const utilisateur_id = localStorage.getItem("utilisateur_id");
    const [isLoading, setIsLoading] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });

    const [groupes, setGroupes] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [groupeSelectionne, setGroupeSelectionne] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Liste Groupe";
        }
    }, [user_id]);

    // États pour gérer le modal
    const [showModal, setShowModal] = useState(false);
    const [nouveauGroupe, setNouveauGroupe] = useState({ titre: "", description: "" });

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
        setTimeout(() => {
            setAlertModal({ message: '', type: '' });
        }, 5000);
    };

    // Récupération des groupes
    const fetchGroupes = async () => {
        const token = localStorage.getItem('access_token')
        try {
            setIsLoading(true);
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-groupes/",
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
            if (response.ok) {
                const data = await response.json();
                setGroupes(data);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Erreur lors de la récupération des groupes:", error);
        }
    };

    useEffect(() => {
        fetchGroupes();
    }, []);

    const colonnesGroupes = [
        //{ titre: "Id", cle: "id" },
        { titre: "Titre", cle: "titre" },
        { titre: "Description", cle: "description" },
        { titre: "Membres", cle: "nombre_utilisateurs" },
    ];

    // Filtrage
    const groupesFiltres = groupes.filter(groupe =>
        groupe?.titre?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        groupe?.description?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Pagination
    const totalItems = groupesFiltres.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const groupesAffiches = groupesFiltres.slice(indexOfFirstItem, indexOfLastItem);

    const handleSelectionGroupe = (groupe) => {
        setGroupeSelectionne(groupe);
    };

    // Gestion du modal
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    // Gestion du formulaire d'ajout
    const handleChange = (e) => {
        setNouveauGroupe({ ...nouveauGroupe, [e.target.name]: e.target.value });
    };

    const handleAjouterGroupe = async () => {
        if (!nouveauGroupe.titre.trim()) {
            showAlert("Le titre du groupe est obligatoire.", "danger");
            return;
        }

        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-groupe/${user_id}/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(nouveauGroupe),
            });

            if (response.ok) {
                fetchGroupes()
                setNouveauGroupe({ titre: "", description: "" });
                handleCloseModal();
                showAlert("Groupe ajouté avec succès", "success");
            } else {
                showAlert("Erreur lors de l'ajout du groupe.", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlert("Une erreur est survenue. Veuillez réessayer.", "danger");
        }
    };


    const handleShowDeleteModal = () => {
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };


    const handleDeleteGroupe = async () => {
        if (groupeSelectionne) {
            const token = localStorage.getItem('access_token');
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-groupe/${groupeSelectionne.id}/${user_id}/`, {
                    method: 'DELETE',
                    headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${token}`
                },
                });

                if (response.ok) {
                    setGroupes(groupes.filter((groupe) => groupe.id !== groupeSelectionne.id));
                    setGroupeSelectionne(null);

                    // Stocker le message de succès dans localStorage
                    showAlert('Groupe supprimé avec succès !');
                } else {
                    console.error('Erreur lors de la suppression du groupe');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const handleConfigurer = (groupe) => {
        if (groupe) {
            navigate(`/Configurer-groupe`, {
                state: { groupe_id: groupe.id }, // Passage de l'ID par l'état
            });
        }
    };


    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            const token = localStorage.getItem('access_token');
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Groupes")) {
        return (
            <Pas_acces />
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <BsPeople size={25} className='mr-2' />Groupes
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation-admin', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'groupes'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <small>Administration des groupes d'utilisateurs.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Groupes
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des groupes</h5>
                            <div className="text-right">
                                <button className="btn btn-success mr-2" onClick={handleOpenModal}>
                                    <FaPlus />Ajouter
                                </button>
                                <button
                                    onClick={() => handleConfigurer(groupeSelectionne)}
                                    className={`btn mb-2 mb-md-0 ms-0 ms-md-2 mr-2 ${groupeSelectionne ? 'btn-success' : 'btn-default text-dark'}`}
                                    disabled={!groupeSelectionne}
                                >
                                    <FaCogs /> Configurer
                                </button>
                                <button
                                    onClick={() => handleShowDeleteModal(groupeSelectionne)}
                                    className={`btn mb-2 mb-md-0 ms-0 ms-md-2 ${groupeSelectionne ? 'btn-success' : 'btn-default text-dark'}`}
                                    disabled={!groupeSelectionne}
                                >
                                    <FaTrash /> Supprimer
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        <TableauDynamique
                                            colonnes={colonnesGroupes}
                                            donnees={groupesFiltres}
                                            isLoading={isLoading}
                                            messageAucun="Aucun groupe trouvé."
                                            onSelectRow={handleSelectionGroupe}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer text-center">
                        {/* <div className="float-right">
                        10GB of <strong>250GB</strong> Free.
                    </div> */}
                        <div>
                            <strong><a href="https://www.adnservicespro.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>ADN Services</a></strong> &copy; 2025. Tous droits réservés | Réalisé par <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>INOVACT SARL</a>
                        </div>
                    </div>
                </div>
            </div>



            <ModalComponent
                show={showModal}
                handleClose={handleCloseModal}
                title="Créer un groupe"
                fields={[
                    { name: "titre", label: "Titre", placeholder: "Titre du groupe", required: true },
                    { name: "description", label: "Description", type: "textarea", placeholder: "Description du groupe", required: true },
                    // { 
                    //     name: "type_groupe", 
                    //     label: "Type du groupe", 
                    //     type: "select", 
                    //     options: [
                    //         { value: "admin", label: "Groupe système" },
                    //         { value: "user", label: "Utilisateur" },
                    //     ], 
                    //     required: true 
                    // }
                ]}
                formData={nouveauGroupe}
                handleChange={handleChange}
                handleSubmit={handleAjouterGroupe}
                submitText="Ajouter"
            />

            {/* Modal de confirmation de suppression */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header>
                    <Modal.Title>Confirmer la suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir supprimer le groupe <strong>{groupeSelectionne?.titre}</strong> ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        <strong>Annuler</strong>

                    </Button>
                    <Button variant="success" onClick={handleDeleteGroupe}>
                        <strong>Supprimer</strong>

                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal pour ajouter un groupe */}
            {/* <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header>
                    <Modal.Title>Ajouter un Groupe</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Titre du groupe</Form.Label>
                            <Form.Control
                                type="text"
                                name="titre"
                                value={nouveauGroupe?.titre}
                                onChange={handleChange}
                                placeholder="titre du groupe"
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                name="description"
                                value={nouveauGroupe?.description}
                                onChange={handleChange}
                                placeholder="Description du groupe"
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Fermer</Button>
                    <Button variant="success" onClick={handleAjouterGroupe}>Ajouter</Button>
                </Modal.Footer>
            </Modal> */}
        </div>
    );
};

export default ListeGroupe;
